// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/vertex.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { ServiceBinding, ServiceBindingJson } from "./service_binding_pb";
import { file_mochabugapis_adapt_plugins_v1_service_binding } from "./service_binding_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/vertex.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_vertex: GenFile = /*@__PURE__*/
  fileDesc("Ciptb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS92ZXJ0ZXgucHJvdG8SHW1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxIrAFCgZWZXJ0ZXgSLQoEbmFtZRgBIAEoCUIfukgcchoQARhkMhReW18kYS16XVtfJGEtejAtOV0qJBIYCgVsYWJlbBgCIAEoCUIJukgGcgQQARhkEicKC2Rlc2NyaXB0aW9uGAMgASgJQg26SArYAQFyBRABGPoBSACIAQESZQoEbG9nbxgEIAEoCUJSukhP2AEBckoQAhiAIDJDXihbXi9dKygvW14vXSspKilcLihnaWZ8anBnfGpwZWd8amZpZnxwanBlZ3xwanB8cG5nfHN2Z3x3ZWJwfGF2aWYpJEgBiAEBElIKDGNhcGFiaWxpdGllcxgFIAMoDjIpLm1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxLkNhcGFiaWxpdHlCEbpIDpIBCxgBIgeCAQQQASAAEjIKBmNvbmZpZxgGIAEoCUIdukgachgQBRiAIDIRXihbXi9dKygvW14vXSspKilIAogBARI2CghtZXRhZGF0YRgHIAEoCUIkukghch8QBRiAIDIYXihbXi9dKygvW14vXSspKilcLmpzb24kEsABCg11c2VyX3NlcnZpY2VzGAggAygLMi0ubW9jaGFidWdhcGlzLmFkYXB0LnBsdWdpbnMudjEuU2VydmljZUJpbmRpbmdCerpId7oBbQocc3lzdGVtX3NlcnZpY2VzX3VuaXF1ZV9uYW1lcxIjYSBuYW1lIGNhbm5vdCBhcHBlYXIgbW9yZSB0aGFuIG9uY2UaKHRoaXMubWFwKHNlcnZpY2UsIHNlcnZpY2UubmFtZSkudW5pcXVlKCmSAQQIABAUEhcKCmRlcHJlY2F0ZWQYCSABKAhIA4gBAUIOCgxfZGVzY3JpcHRpb25CBwoFX2xvZ29CCQoHX2NvbmZpZ0INCgtfZGVwcmVjYXRlZCqLAQoKQ2FwYWJpbGl0eRIaChZDQVBBQklMSVRZX1VOU1BFQ0lGSUVEEAASEwoPQ0FQQUJJTElUWV9DUk9OEAESFwoTQ0FQQUJJTElUWV9FWFRFUk5BTBACEhsKF0NBUEFCSUxJVFlfQ09ORklHVVJBVE9SEAMSFgoSQ0FQQUJJTElUWV9CUk9XU0VSEARiBnByb3RvMw", [file_buf_validate_validate, file_mochabugapis_adapt_plugins_v1_service_binding]);

/**
 * Vertex represents a graph vertex that defines a plugin.
 * Note: Be aware of potential security implications when dealing with
 * user-provided data, such as file paths, and ensure proper input validation
 * and sanitization.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Vertex
 */
export type Vertex = Message<"mochabugapis.adapt.plugins.v1.Vertex"> & {
  /**
   * 'name' represents the vertex name.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * 'description' is a human-friendly short description of the vertex displayed
   * in UI.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * 'logo' is the file path to the vertex logo, which will be resized to a
   * maximum of 40x40 pixels. Ensure that the logo files are from trusted
   * sources to avoid security risks.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 4;
   */
  logo?: string;

  /**
   * 'capabilities' specifies the capabilities of the vertex
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Capability capabilities = 5;
   */
  capabilities: Capability[];

  /**
   * 'config' is an field that contains a Unix file path.
   * This can be any type of file, this is only intepreted for the vertex itself
   * Restrictions:
   *
   *
   * @generated from field: optional string config = 6;
   */
  config?: string;

  /**
   * 'metadata' is an field that contains a Unix file path.
   * This determines which receivers, transmitters etc... the vertex has to begin with
   * Restrictions:
   *
   *
   * @generated from field: string metadata = 7;
   */
  metadata: string;

  /**
   * 'user_services' are the services that the user is defining
   * and consumed by a particular instance of the vertex
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceBinding user_services = 8;
   */
  userServices: ServiceBinding[];

  /**
   * 'deprecated' is a boolean that indicates if the vertex is deprecated
   * this means that it will be removed in the next major version
   * and should be migrated asap
   *
   * @generated from field: optional bool deprecated = 9;
   */
  deprecated?: boolean;
};

/**
 * Vertex represents a graph vertex that defines a plugin.
 * Note: Be aware of potential security implications when dealing with
 * user-provided data, such as file paths, and ensure proper input validation
 * and sanitization.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.Vertex
 */
export type VertexJson = {
  /**
   * 'name' represents the vertex name.
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * 'label' is a human-friendly label displayed in the UI.
   *
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * 'description' is a human-friendly short description of the vertex displayed
   * in UI.
   *
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * 'logo' is the file path to the vertex logo, which will be resized to a
   * maximum of 40x40 pixels. Ensure that the logo files are from trusted
   * sources to avoid security risks.
   * - Supported file formats:
   *   - GIF: .gif
   *   - JPEG: .jpg, .jpeg, .jfif, .pjpeg, .pjp
   *   - PNG: .png
   *   - SVG: .svg
   *   - WEBP: .webp
   *   - AVIF: .avif
   *
   * @generated from field: optional string logo = 4;
   */
  logo?: string;

  /**
   * 'capabilities' specifies the capabilities of the vertex
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.Capability capabilities = 5;
   */
  capabilities?: CapabilityJson[];

  /**
   * 'config' is an field that contains a Unix file path.
   * This can be any type of file, this is only intepreted for the vertex itself
   * Restrictions:
   *
   *
   * @generated from field: optional string config = 6;
   */
  config?: string;

  /**
   * 'metadata' is an field that contains a Unix file path.
   * This determines which receivers, transmitters etc... the vertex has to begin with
   * Restrictions:
   *
   *
   * @generated from field: string metadata = 7;
   */
  metadata?: string;

  /**
   * 'user_services' are the services that the user is defining
   * and consumed by a particular instance of the vertex
   *
   * @generated from field: repeated mochabugapis.adapt.plugins.v1.ServiceBinding user_services = 8;
   */
  userServices?: ServiceBindingJson[];

  /**
   * 'deprecated' is a boolean that indicates if the vertex is deprecated
   * this means that it will be removed in the next major version
   * and should be migrated asap
   *
   * @generated from field: optional bool deprecated = 9;
   */
  deprecated?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.Vertex.
 * Use `create(VertexSchema)` to create a new message.
 */
export const VertexSchema: GenMessage<Vertex, {jsonType: VertexJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_vertex, 0);

/**
 * The capabilities of a vertex defines how the vertex is interracted with
 * If the vertex has the cron capabilitiy, then a cron-scheduler will call the
 * cron endpoint periodically until the vertex has finished or stopped
 * If the vertex has external browser capabiltity, there will be an external endpoint
 * where a third-party can communicate with the vertex
 * If the vertex has a configurator, then the vertex will be able to be configured dynamically
 *
 * @generated from enum mochabugapis.adapt.plugins.v1.Capability
 */
export enum Capability {
  /**
   * Unspecified capability (default value, should not be used).
   *
   * @generated from enum value: CAPABILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Cron capability, indicating that the vertex can be triggered at specific
   * intervals.
   *
   * @generated from enum value: CAPABILITY_CRON = 1;
   */
  CRON = 1,

  /**
   * The external capability, indicating that the vertex can be accessed via a
   * publicly routable address.
   *
   * @generated from enum value: CAPABILITY_EXTERNAL = 2;
   */
  EXTERNAL = 2,

  /**
   * Configurator capability, indicating that the vertex can be configured
   * dynamically by a vertex-defined interface.
   *
   * @generated from enum value: CAPABILITY_CONFIGURATOR = 3;
   */
  CONFIGURATOR = 3,

  /**
   * Browser capability, indicating that the vertex can be accessed via a
   * browser context.
   *
   * @generated from enum value: CAPABILITY_BROWSER = 4;
   */
  BROWSER = 4,
}

/**
 * The capabilities of a vertex defines how the vertex is interracted with
 * If the vertex has the cron capabilitiy, then a cron-scheduler will call the
 * cron endpoint periodically until the vertex has finished or stopped
 * If the vertex has external browser capabiltity, there will be an external endpoint
 * where a third-party can communicate with the vertex
 * If the vertex has a configurator, then the vertex will be able to be configured dynamically
 *
 * @generated from enum mochabugapis.adapt.plugins.v1.Capability
 */
export type CapabilityJson = "CAPABILITY_UNSPECIFIED" | "CAPABILITY_CRON" | "CAPABILITY_EXTERNAL" | "CAPABILITY_CONFIGURATOR" | "CAPABILITY_BROWSER";

/**
 * Describes the enum mochabugapis.adapt.plugins.v1.Capability.
 */
export const CapabilitySchema: GenEnum<Capability, CapabilityJson> = /*@__PURE__*/
  enumDesc(file_mochabugapis_adapt_plugins_v1_vertex, 0);

